// extracted by mini-css-extract-plugin
export default {"container":"Yp-z","heading":"Zp-z","text":"_p-z","info":"aq-z","link":"bq-z","fullMaxWidth":"cq-z"};